<template>
    <div class="datepicker form-group">
        <label
            :for="uniqueId"
            class="form-group-label"
        >
            {{ label }}
        </label>

        <v-date-picker
            v-model="inputValue"
            mode="time"
            is24hr
        >
            <template v-slot="{ inputValue, inputEvents }">
                <div class="input-group">
                    <div class="position-relative d-flex flex-column">
                        <input
                            :value="inputValue"
                            v-on="inputEvents"
                            class="form-control"
                        >
                        <ui-icon
                            icon="clock"
                            class="datepicker-icon"
                        />
                    </div>
                </div>
            </template>
        </v-date-picker>

        <input
            type="text"
            :id="uniqueId"
            :name="name"
            :required="required"
            :value="ISOString"
            class="datepicker-input visually-hidden"
        >
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    import UiIcon from './icon.vue';

    export default {
        name: 'UiTimePicker',
        components: {
            UiIcon,
        },
        props: {
            label: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                default: 'date',
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            value: {
                type: String,
                default: dayjs().toISOString(),
            },
        },
        data() {
            return {
                inputValue: dayjs(this.value ? this.value : new Date()).toDate(),
            };
        },
        computed: {
            ISOString() {
                return dayjs(this.inputValue).toISOString();
            },

            uniqueId() {
                return `datepicker-${this._uid}`;
            },
        },
        watch: {
            inputValue() {
                this.$emit('input', this.ISOString);
            },

            value() {
                this.inputValue = dayjs(this.value).toDate();
            },
        },
    };
</script>

<style lang="scss">
    .datepicker {
        .vc-date,
        .vc-time-icon {
            display: none !important; // stylelint-disable-line
        }
        
        .vc-date-time {
            margin: 0 !important; // stylelint-disable-line
        }
    }
</style>
